export const SECTION_PADDING = 16;
export const SECTION_MARGIN = 16;

export const MIN_WIDTH__REGULAR = 560;
export const MAX_WIDTH__COMPACT = MIN_WIDTH__REGULAR - 1;



// WEBPACK FOOTER //
// ./src/theme/layout.js